import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import {SendMessageForm} from "../../../components/messages/sendMessage";

export const Route = createFileRoute('/_site/messages/')({
    component: () => {
        const navigate = Route.useNavigate();
        return <SendMessageForm
                hideBelow={"lg"}
                onMessageSent={async (data) => {
                await navigate({
                    to: "./$threadId",
                    params: {
                        threadId: data.threadId
                    }
                });
            }} />;
    }
});
